import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { GoogleEventsService } from 'src/app/shared/analyticservice/google-events.service';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: [
    './confirmation-modal.component.scss',
    './confirmation-modal.component.rtl.scss',
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ConfirmationModalComponent implements OnInit {
  @Input() confirmationMessage: any;
  @Output() cancelModal = new EventEmitter();
  @Output() confirmModal = new EventEmitter();
  constructor(private analyticService: GoogleEventsService) {}

  ngOnInit(): void {
    if (this.confirmationMessage == 'AreYouSureYouWantToCancelTheOrder') {
      this.onViewEvent();
    }
  }

  onClickCancel() {
    this.cancelModal.emit(false);
    if (this.confirmationMessage == 'AreYouSureYouWantToCancelTheOrder') {
      this.onCancelEvent();
    } else {
      this.onCancelButtonEvent();
    }
  }
  onClickok() {
    this.confirmModal.emit(true);
    if (this.confirmationMessage == 'AreYouSureYouWantToCancelTheOrder') {
      this.onOrderCancelEvent();
    } else {
      this.onreceviedlEvent();
    }
  }
  // <---------- Google Analytics Events Starts  --------->
  onViewEvent() {
    let action = 'ViewScreen';
    let category = 'Tracking Activity';
    let label = 'View OrderCancel';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  onCancelEvent() {
    let action = 'CloseOrderCancelClicked';
    let category = 'Editing Order Activity';
    let label = 'Click CloseOrderDetails';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  onOrderCancelEvent() {
    let action = 'refund';
    let category = 'Editing Order Activity';
    let label = 'OrderCanceled';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  onreceviedlEvent() {
    let action = 'Received';
    let category = 'Orders Activity';
    let label = 'Click OkButton';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  onCancelButtonEvent() {
    let action = 'ClickCancel';
    let category = 'Orders Activity';
    let label = 'Click cancelButton';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  // <---------- Google Analytics Events Ends  --------->
}
